<template>
  <div>
    <div class="suggestedArea  doctorsList">
      <div class="px-3">
        <div class="titleQuestionItem">
          بهترین درمانگران پیشنهادی برای شما
        </div>
        <div class="descQuestionItem">
          با تحلیل شرح حالت و ترجیحاتت، این مشاور رو به‌عنوان بهترین همراه برات پیشنهاد می‌کنیم.
        </div>

        <v-row class="mt-5">
          <v-col cols="12" lg="2"></v-col>
          <v-col cols="12" lg="3" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="filterArea">
              <div class="headerFilter d-flex flex-column justify-center pt-6">
                <div class="d-flex">
                  <div>
                    <img src="../../assets/image/user-journey/filter.svg" alt="">
                  </div>
                  <div>
                    فیلتر درمانگران
                  </div>
                </div>
              </div>
              <div class="filterContext">
                <div class="filterItem" v-if="appliedFiltersCount">
                  <div class="d-flex justify-space-between">
                    <div class="filterTitle">
                      فیلترهای اعمال شده
                    </div>
                    <div class="removeAllFilters" @click="clearAllFilters">
                      <span>حذف همه</span>
                      <v-icon small color="#616161">mdi-close</v-icon>
                    </div>
                  </div>
                  <div class="filterDetail d-flex flex-wrap align-center">
                    <div class="appliedFiltersContainer">

                      <div class="appliedFilterTags">
                        <!-- Days filters -->
                        <div
                            v-for="day in activeDays"
                            :key="`day-${day.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="toggleDayFilter(day.value)">mdi-close</v-icon>
                          <span>{{ day.label }}</span>
                        </div>

                        <!-- Time slot filter -->
                        <div
                            v-for="timeSlot in activeTimeSlots"
                            :key="`time-${timeSlot.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="toggleTimeSlotFilter(timeSlot.value)">mdi-close</v-icon>
                          <span>{{ timeSlot.label }}</span>
                        </div>

                        <!-- Gender filter -->
                        <div
                            v-for="gender in activeGenders"
                            :key="`gender-${gender.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="selectGenderFilter(gender.value)">mdi-close</v-icon>
                          <span>{{ gender.label }}</span>
                        </div>

                        <!-- Immigration experience -->
                        <div
                            v-if="filters.immigration_experience"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="clearImmigrationExperience">mdi-close</v-icon>
                          <span>تراپیست دارای تجربه مهاجرت</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filterItem">
                  <div class="filterTitle">
                    روز های هفته
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div
                        v-for="day in filterOptions.days"
                        :key="day.id"
                        class="filterOptionSelect"
                        :class="{ 'filterOptionSelectActive': isFilterActive('days', day.value) }"
                        @click="toggleDayFilter(day.value)"
                    >
                      {{ day.label }}
                    </div>
                  </div>
                </div>
                <div class="filterItem">
                  <div class="filterTitle">
                    زمان برگزاری جلسه
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div class="filterOptionCheckBox">
                      <v-checkbox
                          v-for="timeSlot in filterOptions.timeSlots"
                          :key="timeSlot.id"
                          :value="timeSlot.value"
                          v-model="filters.timeSlots"
                          dense
                      >
                        <template v-slot:label>
                          <div class="filterOptionCheckBoxRadio">
                            {{ timeSlot.label }}
                            <span style="color:#616161;">
                              {{ timeSlot.description }}
                            </span>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </div>
                <div class="filterItem" style="border-bottom: none">
                  <div class="filterTitle">
                    مشخصات تراپیست
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div
                        v-for="gender in filterOptions.therapist_gender"
                        :key="gender.id"
                        class="filterOptionSelect"
                        :class="{ 'filterOptionSelectActive': isFilterActive('therapist_gender', gender.value) }"
                        @click="selectGenderFilter(gender.value)"
                    >
                      {{ gender.label }}
                    </div>
                  </div>
<!--                  <div class="d-flex justify-space-between mt-3">-->
<!--                    <v-row>-->
<!--                      <v-col cols="6">-->
<!--                        <div class="">-->
<!--                          تراپیست دارای تجربه مهاجرت-->
<!--                        </div>-->
<!--                      </v-col>-->
<!--                      <v-col cols="6">-->
<!--                        <div style="padding-top: -30px" class="">-->
<!--                          <v-switch-->
<!--                              dense-->
<!--                              style="margin-top: -20px;transform: rotate(180deg)"-->
<!--                              v-model="filters.immigration_experience"-->
<!--                              @change="onImmigrationToggle"-->
<!--                          />-->
<!--                        </div>-->
<!--                      </v-col>-->
<!--                    </v-row>-->


<!--                  </div>-->

                </div>

              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="5" v-if="visibleTherapists.length">
            <div class="filterBox mb-5 d-flex flex-column justify-center " @click="filterBottomSheet = true"
                 v-if="this.$vuetify.breakpoint.mdAndDown">
              <div class="d-flex">
                <div class="pt-1">
                  <img src="../../assets/image/user-journey/filter.svg" alt="">
                </div>
                <div class="headerFilterMobile  mr-1 d-flex align-center">
                  فیلتر درمانگران
                  <div v-if="appliedFiltersCount > 0" class="filterCountBadge">
                    {{ appliedFiltersCount }}
                  </div>
                </div>
                <v-spacer></v-spacer>
                <div class="pt-1">
                  <img src="../../assets/image/user-journey/chevron-left.svg" alt="">

                </div>
              </div>
            </div>
            <transition name="doctor-fade" mode="out-in">
              <div key="112" v-if="loading" class="skeleton-container">
                <div class="doctorBox-skeleton">
                  <div class="skeleton-header">
                    <div class="skeleton-avatar"></div>
                    <div class="skeleton-info">
                      <div class="skeleton-line skeleton-line-lg"></div>
                      <div class="skeleton-line skeleton-line-md"></div>
                    </div>
                  </div>
                  <div class="skeleton-divider"></div>
                  <div class="skeleton-footer">
                    <div class="skeleton-appointment">
                      <div class="skeleton-line skeleton-line-sm"></div>
                      <div class="skeleton-line skeleton-line-md"></div>
                    </div>
                    <div class="skeleton-button"></div>
                  </div>
                </div>
              </div>
              <div key="1222" v-else>
                <div
                    class="doctorBox"
                    v-for="(item , i) in visibleTherapists"
                    :key="i"
                >
                  <div class="headerDoctorBox">
                    <div class="d-flex">
                      <div>
                        <img
                            :src="item.user?.avatar || placeholderAvatar"
                            class="doctorAvatar"
                            :alt="`عکس ${item.user?.full_name || 'درمانگر'}`"
                        />
                      </div>
                      <div class="d-flex flex-column justify-center">
                        <div>
                          <div class="nameDoctor">
                            دکتر {{ item.user?.full_name || '—' }}
                          </div>
                          <div class="subTitleDoctor ">
                            {{ item.subtitle || '—' }}
                          </div>
                          <div class="d-flex" v-if="item.immigration_experience">
                           <div class="immigrationExperience">
                             تجربه مهاجرت
                           </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bodyDoctor">
                    <div class="d-flex  justify-space-between" :class="$vuetify.breakpoint.mdAndDown && 'flex-column'">
                      <div class="detailItem">
                        <div class="iconDetail d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/brain.svg" alt="رویکرد"/>
                        </div>
                        <div class="nameDetail mx-1 d-flex flex-column justify-center">
                          رویکرد:
                        </div>
                        <div class="valueDetail">
                          {{ firstModality(item) }}
                        </div>
                      </div>
                      <div class="detailItem">
                        <div class="iconDetail d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/work.svg" alt="تجربه کاری"/>
                        </div>
                        <div class="nameDetail mx-1 d-flex flex-column justify-center">
                          تجربه کاری :
                        </div>
                        <div class="valueDetail d-flex">
                          <div style="direction: ltr !important;">
                            {{ item.years_of_experience }}
                          </div>
                          <div class="mr-1">
                            {{ item.years_of_experience ? ` سال` : '—' }}

                          </div>
                        </div>
                      </div>
                      <div class="detailItem" v-if="!isDesktop">
                        <div class="iconDetail d-flex flex-column justify-center">
                          <img src="../../assets/image/user-journey/clock.svg" alt="تجربه کاری"/>
                        </div>
                        <div class="nameDetail mx-1 d-flex flex-column justify-center">
                          اولین نوبت آزاد:
                        </div>
                        <div class="valueDetail d-flex">
                          {{ firstFreeTime(item) }}
                        </div>
                      </div>
                    </div>

                    <div class="overviewBox mb-5">
                      <div class="d-flex justify-space-between">
                        <v-row>
                          <v-col cols="4" lg="4" class="pa-0 ma-0">
                            <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                              <img src="../../assets/image/user-journey/star-filled.svg" alt="">
                              <div class="overviewItemTextArea d-flex justify-center ">
                                <div class="scoreOverview d-flex flex-column justify-center">
                                  {{ item.rating }}
                                </div>
                                <div class="titleOverview mt-1 mr-1">
                                  امتیاز
                                </div>
                              </div>

                            </div>
                          </v-col>
                          <v-col cols="4" lg="4" class="pa-0 ma-0">
                            <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                              <img src="../../assets/image/user-journey/video_icon.svg" alt="">
                              <div class="overviewItemTextArea d-flex justify-center ">
                                <div class="scoreOverview" style="direction: ltr">
                                  +

                                  {{ Number(item.held_sessions).toLocaleString() || '—' }}
                                </div>
                                <div class="titleOverview mr-1">
                                  جلسه موفق
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="4" lg="4" class="pa-0 ma-0">
                            <div class="overviewItem text-center ">
                              <img src="../../assets/image/user-journey/thumb-up-filled_2.svg" alt="">
                              <div class="overviewItemTextArea d-flex justify-center ">
                                <div class="scoreOverview" style="direction: ltr">
                                    {{ item.user_suggestion }}%
                                </div>
                                <div class="titleOverview mr-1">
                                  پیشنهاد کاربران
                                </div>
                              </div>

                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                  </div>


                  <div class="actionDoctorBox d-flex" v-if="isDesktop">
                    <div>
                      <div class="firstEmptyTimeTitle">اولین نوبت آزاد:</div>
                      <div class="firstEmptyTimeValue">
                        {{ firstFreeTime(item) }}
                      </div>
                    </div>
                    <div class="flex-grow-1 pr-15">
                      <v-btn
                          color="primary"
                          block
                          elevation="0"
                          class="setDoctorAction"
                          @click="handleSelect(item)"
                          aria-label="بررسی و رزرو نوبت"
                      >
                        مشاهده جزئیات و نوبت‌ها
                      </v-btn>
                    </div>
                  </div>
                  <div class="pa-3" v-else>
                    <div>
                      <v-btn
                          color="primary"
                          block
                          elevation="0"
                          class="setDoctorAction"
                          @click="handleSelect(item)"
                          aria-label="بررسی و رزرو نوبت"
                      >
                        مشاهده جزئیات و نوبت‌ها
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-5">
                  <v-btn
                      v-if="hasMore"
                      color="#035184"
                      class="font-weight-bold"
                      text
                      @click="showNext()"
                      aria-label="مشاهده درمانگر بعدی"
                  >
                    مشاهده درمانگر بعدی
                  </v-btn>
                </div>
              </div>
            </transition>


          </v-col>
          <v-col cols="12" lg="5" v-else>
            <div class="filterBox mb-5 d-flex flex-column justify-center " @click="filterBottomSheet = true"
                 v-if="this.$vuetify.breakpoint.mdAndDown">
              <div class="d-flex">
                <div class="pt-1">
                  <img src="../../assets/image/user-journey/filter.svg" alt="">
                </div>
                <div class="headerFilterMobile  mr-1 d-flex align-center">
                  فیلتر درمانگران
                  <div v-if="appliedFiltersCount > 0" class="filterCountBadge">
                    {{ appliedFiltersCount }}
                  </div>
                </div>
                <v-spacer></v-spacer>
                <div class="pt-1">
                  <img src="../../assets/image/user-journey/chevron-left.svg" alt="">

                </div>
              </div>
            </div>

            <div class="text-center fill-height d-flex flex-column justify-center">
              <div>
                <img src="../../assets/image/user-journey/OBJECTS.svg" alt="">
                <div class="titleEmpty">
                  متاسفانه در حال حاضر تراپیست مناسبی برای شما پیدا نشد.
                </div>
                <div class="descEmpty mb-10">
                  برای ترجییحات شما تراپیستی وجود ندارد.
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="2"></v-col>
        </v-row>
      </div>
      <PreSessionBox text="اگر همچنان سوال یا ابهامی در رابطه با انتخاب تراپیست دارید، کارشناسان ما همراه شما هستند"
                     class="mt-15"/>


      <v-bottom-sheet style="border-radius: 16px 16px 0px 0px " v-model="filterBottomSheet" fullscreen height="100%"
                      scrollable>
        <div class="resume-sheet">
          <div class="bg-headerResume">
            <div class="headerResume  ">
              <div class="d-flex">
                <div class="d-flex flex-column justify-center">
                  <img src="../../assets/image/user-journey/arrow-narrow-right-black.svg"
                       @click="filterBottomSheet = !filterBottomSheet" alt="">
                </div>
                <div class="flex-grow-1 mr-2 titleHeader">
                  فیلتر درمانگران
                </div>
              </div>
            </div>
          </div>
          <div class="sheet-scroll  " id="sheetScroll">
            <div class="filterArea">
              <div class="filterContext">
                <div class="filterItem" v-if="appliedFiltersCount">
                  <div class="d-flex justify-space-between">
                    <div class="filterTitle">
                      فیلترهای اعمال شده
                    </div>

                  </div>
                  <div class="filterDetail d-flex flex-wrap align-center">
                    <div class="appliedFiltersContainer">

                      <div class="appliedFilterTags">
                        <!-- Days filters -->
                        <div
                            v-for="day in activeDays"
                            :key="`day-${day.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="toggleDayFilter(day.value)">mdi-close</v-icon>
                          <span>{{ day.label }}</span>
                        </div>

                        <!-- Time slot filter -->
                        <div
                            v-for="timeSlot in activeTimeSlots"
                            :key="`time-${timeSlot.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="toggleTimeSlotFilter(timeSlot.value)">mdi-close</v-icon>
                          <span>{{ timeSlot.label }}</span>
                        </div>

                        <!-- Gender filter -->
                        <div
                            v-for="gender in activeGenders"
                            :key="`gender-${gender.id}`"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="selectGenderFilter(gender.value)">mdi-close</v-icon>
                          <span>{{ gender.label }}</span>
                        </div>

                        <!-- Immigration experience -->
                        <div
                            v-if="filters.immigration_experience"
                            class="appliedFilterTag"
                        >
                          <v-icon small color="#39C990" @click="clearImmigrationExperience">mdi-close</v-icon>
                          <span>تراپیست دارای تجربه مهاجرت</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filterItem">
                  <div class="filterTitle">
                    روز های هفته
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div
                        v-for="day in filterOptions.days"
                        :key="day.id"
                        class="filterOptionSelect"
                        :class="{ 'filterOptionSelectActive': isFilterActive('days', day.value) }"
                        @click="toggleDayFilter(day.value)"
                    >
                      {{ day.label }}
                    </div>
                  </div>
                </div>
                <div class="filterItem">
                  <div class="filterTitle">
                    زمان برگزاری جلسه
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div class="filterOptionCheckBox">
                      <v-checkbox
                          v-for="timeSlot in filterOptions.timeSlots"
                          :key="timeSlot.id"
                          :value="timeSlot.value"
                          v-model="filters.timeSlots"
                          dense
                      >
                        <template v-slot:label>
                          <div class="filterOptionCheckBoxRadio">
                            {{ timeSlot.label }}
                            <span style="color:#616161;">
                              {{ timeSlot.description }}
                            </span>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </div>
                <div class="filterItem mb-15" style="border-bottom: none">
                  <div class="filterTitle">
                    مشخصات تراپیست
                  </div>
                  <div class="filterDetail d-flex flex-wrap">
                    <div
                        v-for="gender in filterOptions.therapist_gender"
                        :key="gender.id"
                        class="filterOptionSelect"
                        :class="{ 'filterOptionSelectActive': isFilterActive('therapist_gender', gender.value) }"
                        @click="selectGenderFilter(gender.value)"
                    >
                      {{ gender.label }}
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="actionMobile">
          <v-row>
            <v-col cols="6">
              <div class="doneBtn">
                <v-btn class="nextBtn" color="#3CBE8B" block id="confirm_btn" elevation="0" @click="saveFilters">
                  اعمال فیلتر
                </v-btn>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="doneBtn">
                <v-btn class="nextBtnOutline" color="#757575" outlined block id="confirm_btn" elevation="0"
                       @click="clearAllFilters">
                  حذف فیلتر
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
/* eslint-disable */


import moment from "moment-jalaali";
import PreSessionBox from './PreSessionBox.vue'
import {resolveJourneyToken} from "@/utils/journeyToken";
/* eslint-disable */

export default {
  name: "SuggestedTherapists",
  props: {
    therapists: {
      type: Array,
      default: () => [],
    },
    sessionToken: {
      type: String,
      default: null,
    },
    initialCount: {
      type: Number,
      default: 1,
    },
  },
  components: {PreSessionBox},
  data() {
    return {
      loading: false,
      filterBottomSheet: false,
      pageTherapists: [],
      count: this.initialCount,
      timer: null,
      placeholderAvatar: "https://dummyimage.com/100x100/DBE4ED/ffffff.png&text=%20", // simple fallback
      filters: {
        days: [], // Multi-select for days of week
        timeSlots: null, // Multi-select for time slots
        therapist_gender: null, // Single select for gender
        immigration_experience: false, // Therapist has immigration experience
      },
      filterOptions: {
        days: [
          {id: 1, label: 'شنبه', value: '7'},
          {id: 2, label: 'یک شنبه', value: '1'},
          {id: 3, label: 'دو شنبه', value: '2'},
          {id: 4, label: 'سه شنبه', value: '3'},
          {id: 5, label: 'چهار شنبه', value: '4'},
          {id: 6, label: 'پنج شنبه', value: '5'},
          {id: 7, label: 'جمعه', value: '6'}
        ],
        timeSlots: [
          {id: 1, label: 'صبح ها', description: '(در ساعات اداری 8:00تا 17:00 )', value: 'business_hours'},
          {
            id: 2,
            label: 'بعد از ظهر',
            description: '( بعد از ساعات اداری 17:00 تا 00:00 )',
            value: 'after_business_hours'
          }
        ],
        therapist_gender: [
          {id: 1, label: 'زن', value: 'FEMALE'},
          {id: 2, label: 'مرد', value: 'MALE'}
        ]
      }
    };
  },
  computed: {
    visibleTherapists() {
      return Array.isArray(this.pageTherapists)
          ? this.pageTherapists.slice(0, this.count)
          : [];
    },
    hasMore() {
      return this.count < this.pageTherapists.length && this.count < 3;
    },
    isMobile() {
      return this.$vuetify && this.$vuetify.breakpoint.mdAndDown;
    },
    isDesktop() {
      return this.$vuetify && this.$vuetify.breakpoint.mdAndUp;
    },
    activeDays() {
      return this.filterOptions.days.filter(day => this.isFilterActive('days', day.value));
    },
    activeTimeSlots() {
      return this.filterOptions.timeSlots.filter(timeSlot => this.isFilterActive('timeSlots', timeSlot.value));
    },
    activeGenders() {
      return this.filterOptions.therapist_gender.filter(gender => this.isFilterActive('therapist_gender', gender.value));
    },
    appliedFiltersCount() {
      let count = 0;
      count += this.filters.days.length; // Days are multi-select
      count += this.filters.timeSlots ? 1 : 0; // Time slot is single select
      count += this.filters.therapist_gender ? 1 : 0; // Gender is single select
      count += this.filters.immigration_experience ? 1 : 0; // Immigration experience toggle
      return count;
    },
  },
  methods: {
    showNext() {
      if (this.hasMore) {
        this.count = Math.min(this.count + 1, this.therapists.length);
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          })
        }, 500)
      }
    },
    handleSelect(therapist) {
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 95)
      // keep existing contract with parent
      this.$emit("changeStateFlow", {state: "select_time", doctor_id: therapist.id});
      // this.$emit("selectDoctor", therapist);
    },
    formatDateJalali(dateStr) {
      if (!dateStr) return "—";
      moment.loadPersian({dialect: "persian-modern", usePersianDigits: false});
      return moment(dateStr, "YYYY-MM-DD HH:mm").format("dddd،  YYYY/MM/DD");
    },
    firstFreeTime(item) {
      const dt = item?.user?.dates_and_times?.[0]?.from_time;
      return this.formatDateJalali(dt);
    },
    firstModality(item) {
      const mods = item?.therapeutic_modalities;
      return Array.isArray(mods) && mods.length ? (mods[0].title_fa || "—") : "—";
    },
    // Filter methods
    toggleDayFilter(dayValue) {
      const index = this.filters.days.indexOf(dayValue);
      if (index > -1) {
        this.filters.days.splice(index, 1);
      } else {
        this.filters.days.push(dayValue);
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 500)
      }
    },
    toggleTimeSlotFilter(timeValue) {
      // Single select - replace current selection
      this.filters.timeSlots = this.filters.timeSlots === timeValue ? null : timeValue;
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 500)
      }
    },
    selectGenderFilter(genderValue) {
      // Single select - replace current selection
      this.filters.therapist_gender = this.filters.therapist_gender === genderValue ? null : genderValue;
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 500)
      }
    },
    onImmigrationToggle() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 300)
      }
    },
    saveFilters() {
      const token = resolveJourneyToken(this.sessionToken)
      if (!token) {
        return
      }
      this.loading = true
      this.filterBottomSheet = false
      this.filters.token = token
      this.filters.shift = this.filters.timeSlots
      this.count = 1
      const payload = {...this.filters}
      if (!payload.immigration_experience) {
        delete payload.immigration_experience
      }
      this.requesting('match_making', 'filterDoctor', {}, payload).then((resp) => {
        this.pageTherapists = resp.data.doctors
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
          this.$emitEvent('setLoading', false)
        }, 1000)
      })
    },
    applyFilters() {
      // This method can be used to filter the therapists list
      // For now, we'll just emit the filters to parent component
      this.$emit('applyFilters', this.filters);
    },
    clearAllFilters() {
      this.filters = {
        days: [],
        timeSlots: null,
        therapist_gender: null,
        immigration_experience: false,
      };
      this.saveFilters();
    },
    clearImmigrationExperience() {
      this.filters.immigration_experience = false
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 300)
      } else {
        // on mobile don't auto-close; just keep state and let user apply/clear
      }
    },
    isFilterActive(filterType, value) {
      switch (filterType) {
        case 'days':
          return this.filters.days.includes(value);
        case 'timeSlots':
          return this.filters.timeSlots === value;
        case 'therapist_gender':
          return this.filters.therapist_gender === value;
        default:
          return false;
      }
    },
  },
  mounted() {
    this.pageTherapists = this.therapists
    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 90)
  },
  watch: {
    'filters.timeSlots'() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.saveFilters();
        }, 500)
      }
    },
    therapists() {
      // was `$emitEvent` (undefined). Assuming parent expects this emit.
      this.$emit("setCurrentStep", 2);
      // reset pagination if the list changes
      this.count = this.initialCount;
    },
  },
};
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .titleOverview{
    font-size: 11px !important;
  }
  .presessionBtn {
    margin-top: 20px;
  }

  .titlePresession {
    font-size: 16px !important;
  }

  .filterArea {
    border-radius: 0px !important;
    margin-top: 10px !important;
    border: none !important;
  }

  .filterContext {
    padding: 0px 16px 16px 16px !important;
  }


  .suggestedArea {
    margin-top: 40px !important;
  }

  .titleQuestionItem {
    font-size: 20px !important;
  }

  .descQuestionItem {
    font-size: 16px;
  }

  .doctorBox {
    width: 100% !important;
    margin: 0px auto 15px auto !important;
  }

  .nameDoctor {
    font-size: 20px !important;
  }

  .subTitleDoctor {
    font-size: 14px !important;
  }

  .doctorAvatar {
    width: 85px !important;
    height: 85px !important;
  }

  .ratingLabel {
    font-size: 16px !important;

  }

  .headerDoctorBox {
    margin: 16px 16px 0px 16px !important;
  }

  .detailItem {
    margin-bottom: 16px;
  }

  .bodyDoctor {
    margin: 16px 16px 0px 16px !important;
  }

  .actionMobile {
    padding: 16px 20px 15px 20px;
    position: fixed;
    right: 0px !important;
    width: 100% !important;
    left: 0px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
    border-radius: 0px !important;
  }
  .immigrationExperience{
    margin-bottom: 10px;
  }
}

a {
  text-decoration: none;
}


.nextBtn {
  height: 50px !important;
  color: white !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  border-radius: 8px;
}

.nextBtnOutline {
  height: 50px !important;
  color: #757575 !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  border-radius: 8px;
}

.doneBtn {
  border-radius: 8px !important;
}

.resume-sheet {
  height: 100vh;
  display: flex;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  flex-direction: column;
  background: white;
}

.sheet-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  //background: #f6f9fc;
  background: white;
  //background: red;
  -webkit-overflow-scrolling: touch;
}

.headerResume {
  padding: 16px 24px;
  border-bottom: 1px solid var(--Bluegray-bluegray-lighten-2, #EAF0F6);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  position: sticky;
  top: 0;
  background: #FFF;
  z-index: 2;
  margin-bottom: 3px
}

.bg-headerResume {
  background: #f6f9fc;
  padding-bottom: 10px;
}

.filterBox {
  background: #F6F9FC;
  border: 1px solid #EAF0F6;
  padding: 10px 16px;
  border-radius: 8px;
}

.valueDetail {
  font-family: "YekanBakh", "Roboto" !important;
  color: #212121;
  font-size: 16px;
  font-style: normal;
  margin-top: 0px;
  font-weight: 700;
  line-height: normal;
}

.titleEmpty {
  color: #212121;
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.descEmpty {
  color: #212121;
  text-align: center;
  font-size: 18px;
  margin-top: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submitBtn {
  border-radius: 8px;
  background: #39C990 !important;
  width: 100%;
  height: 48px !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-top: 0px;
  color: white !important;
}

.outLineSubmitBtn {
  display: flex;
  width: 100%;
  height: 48px !important;
  padding: 0 19.55px;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #39C990;
  align-items: center;
  color: #39C990 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.doctorAvatar {
  width: 120px;
  height: 120px;
}

.setDoctorActionMobile {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  height: 48px !important;
  background: #39C990;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.setDoctorAction {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  height: 56px !important;
  background: #39C990;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.firstEmptyTimeTitle {
  color: #616161;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.firstEmptyTimeValue {
  color: #424242;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.bodyDoctor {
  margin: 28px 28px 0px 28px;
}

.actionDoctorBox {
  margin-top: 32px;
  border-radius: 0 0 16px 16px;
  background: #FFF;
  box-shadow: 0 -2px 4px 0 #F4F8FD;
  padding: 28px;
}

.headerDoctorBox {
  border-bottom: 1px solid #EEE;
  margin-bottom: 24px;
  margin: 28px 28px 0px 28px;
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.nameDoctor {
  color: #212121;
  text-align: right;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.subTitleDoctor {
  color: #616161;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.immigrationExperience{
  background: rgba(197, 239, 254, 0.5);
  color: rgba(3, 81, 132, 1);
  padding: 4px 8px;
  border-radius: 8px;
  margin-top: 8px;
}

.ratingLabel {
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  margin-right: 5px;
}

.ratingIcon img {
  width: 20px;
}

.doctorBox {
  border-radius: 16px;
  border: 1px solid #DBE4ED;
  padding: 0px;
  background: #FFF;
  margin: 0px 0 15px 0;
}

.filterArea {
  border-radius: 16px;
  border: 1px solid #DBE4ED;
  padding: 0px;
  background: #FFF;
  margin: 0px auto 15px auto;
  position: sticky;
  top: 20px;
}

.headerFilter {
  padding: 16px;
  border-bottom: 1px solid #DBE4ED;
  font-weight: 700;
  font-size: 18px;
}

.headerFilterMobile {
  font-weight: 500;
  font-size: 16px;
}

.filterCountBadge {
  background: #39C990;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-right: 8px;
  margin-left: 8px;
}

.filterContext {
  padding: 16px;
}


.filterDetail {
  margin-top: 10px;
}

.filterOptionSelect {
  min-width: 62px;
  min-height: 40px;
  border-radius: 8px;
  border: 1px solid #EAF0F6;
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  justify-content: center;
  text-align: center;
  margin-left: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #FFF;
  color: #424242;
}

.filterOptionSelect:hover {
  background: #F6F9FC;
}

.filterOptionSelectActive {
  border: 1px solid #39C990 !important;
  background: #ebfaf4 !important;
  color: #39C990 !important;
}

.filterItem {
  border-bottom: 1px solid #EAF0F6;
  margin-top: 15px;
  padding-bottom: 10px;
}

.filterTitle {
  font-weight: 500;
  font-size: 16px;
  color: #424242;
}

.filterOptionCheckBoxRadio {
  font-weight: 500;
  font-size: 16px;
  color: black;
  text-align: right;
}

.descQuestionItem {
  color: #212121;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

.suggestedArea {
  margin-top: 90px;
}

.clearFiltersBtn {
  border-radius: 8px !important;
  border: 1px solid #39C990 !important;
  color: #39C990 !important;
  font-weight: 600 !important;
  text-transform: none !important;
  height: 40px !important;
}

.clearFiltersBtn:hover {
  background: rgba(57, 201, 144, 0.05) !important;
}

.filterActions {
  border-top: 1px solid #EAF0F6;
  padding-top: 16px;
}

.appliedFiltersContainer {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.removeAllFilters {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.removeAllFilters:hover {
  background: rgba(97, 97, 97, 0.1);
}

.appliedFilterTags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.appliedFilterTag {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #FFF;
  border: 1px solid #39C990;

  border-radius: 8px;
  padding: 6px 12px;
  color: #39C990;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.appliedFilterTag:hover {
  background: rgba(57, 201, 144, 0.1);
}

.appliedFilterTag .v-icon {
  cursor: pointer;
  opacity: 0.8;
}

.appliedFilterTag .v-icon:hover {
  opacity: 1;
}

/* Custom Doctor Fade Transition */
.doctor-fade-enter-active {
  transition: all 0.3s ease-out;
}

.doctor-fade-leave-active {
  transition: all 0.2s ease-in;
}

.doctor-fade-enter {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
}

.doctor-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.98);
}

.doctor-fade-enter-to,
.doctor-fade-leave {
  opacity: 1;
  transform: translateY(0) scale(1);
}

/* Skeleton Loader Styles */
.skeleton-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.doctorBox-skeleton {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #DBE4ED;
  padding: 28px;
  position: relative;
  overflow: hidden;
}

.doctorBox-skeleton::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  animation: skeleton-shimmer 1.5s infinite;
}

.skeleton-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.skeleton-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  margin-left: 20px;
  animation: skeleton-wave 1.5s infinite;
}

.skeleton-info {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 8px;
  animation: skeleton-wave 1.5s infinite;
}

.skeleton-line-lg {
  width: 70%;
  height: 24px;
}

.skeleton-line-md {
  width: 50%;
  height: 18px;
}

.skeleton-line-sm {
  width: 30%;
  height: 16px;
}

.skeleton-rating {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.skeleton-star {
  width: 20px;
  height: 20px;
  background: #f0f0f0;
  border-radius: 2px;
  margin-left: 5px;
}

.skeleton-divider {
  height: 1px;
  background: #EEE;
  margin: 24px 0;
}

.skeleton-details {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}

.skeleton-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: flex-end;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-right: 10px;
}

.skeleton-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.skeleton-appointment {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 16px;
}

.skeleton-button {
  width: 100%;
  height: 56px;
  background: #f0f0f0;
  border-radius: 8px;
}

@keyframes skeleton-shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes skeleton-wave {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.overviewBox {
  margin-top: 10px;
  border-radius: 10px;
  background: #f6f9fc;
  padding: 16px;
}

.overviewItem {
  width: 100%;
  padding: 10px;
}

.scoreOverview {
  font-size: 14px;
  color: #424242;
  font-weight: 700;
}

.titleOverview {
  font-size: 12px;
  color: #616161;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

</style>
